<template>
  <div>
    dashboard
  </div>
</template>

<script>
export default {
  name: 'Taobao2youDashboard',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>